import RsrCancel from "@/views/crud/modules/RsrCancel";
import RsrPenalty from "@/views/crud/modules/RsrPenalty.vue";
import ListButton from "@/views/crud/modules/ListButton";

export default {
    key: "cpRsrPointRedeem",
    id: "rsr_id",
    // type: "readonly",
    action: ["edit"],
    export: ["excel"],
    excel: {
        //max_row:"50000"
    },
    sort: {
        field: "rsr_id",
        order: "desc"
    },
    sort_fields: [

    ],
    filters:{
        external_account_id:{},
    },

    options: {
    },
    fields:[
        // { key: "id", field:"rsr_id", width:50},
        {key: "rsr_id", width: 50},
        { key: "external_account_id"},

        // { key: "mall_id"},
        { key: "loc_address"},
        { key: "carpark_id"},
        {
            key: "bay_name",
            type: "href",
            url: "bay/",
            url_key: [
                {
                    search_key: "id",
                    row_key: "bay_id_int",
                    str: ""
                }
            ]
        },
        // { key: "bay_id"},
        { key: "cp_no"},
        { key: "connector_name"},
        { key: "status", width:80},

        // { key : "current_unit_session"},
        { key : "max_charging_unit"},
        // {key: "charging_fee"},
        // {key: "penalty_fee"},
        {key: "point"},
        // {key: "redeem_voucher_sessions"},
        // {key: "redeem_voucher_size"},

        // { key: "connector_id", width:80},
        // {
        //     key: "tran_id",
        //     width:80,
        //     type: "href",
        //     url:"cp_sessions/",
        //     url_key:[
        //         {
        //             search_key:"id_tag",
        //             row_key:"rsr_id",
        //             str:"RSR:"
        //         }
        //     ]
        // },
        // {
        //     key: "payment_result_id",
        //     type: "href",
        //     url: "payment_result_detail/",
        //     url_key: [
        //         {
        //             search_key: "resultId",
        //             row_key: "payment_result_id",
        //             str: ""
        //         }
        //     ]
        // },
        // tran_id:{
        //     type: "href",
        //     url:"cp_sessions/",
        //     url_key:[
        //         {
        //             key:"id_tag",
        //             str:"RSR:"
        //         }
        //     ]
        // },
        // { key: "lp", width:80},
        // { key: "start_code", width:70},
        // { key: "rate", width:70},
        // { key: "unit_in_minutes", width:100},
        // { key: "end_time", type: "datetime"},
        // { key: "stop_reason", },
        // { key: "actual_end_time", type: "datetime"},
        { key: "cre_dttm", type: "datetime"},
        // {key : "next_available_redeem_date_from_create_date"},

        // { key: "lupd_dttm", type: "datetime"},
        // { key: "actual_finished_time", type: "datetime"},


        // {type: "action-btn"},

        // {key: "is_free"}

        // { key: "uuid"},
    ],
    structure:[
        ["start_time"],
        ["gracing_period_end_dttm"],
        ["ev_disconnect_time"],
        ["actual_finished_time"],
    ]
}